import UI from '../../components/ExcerciseTypes/Design/UserInterface'
import D1 from '../../components/ExcerciseTypes/Design/TypeIn'
import T6 from '../../components/ExcerciseTypes/TypeIn/T6'
import Circle_Write from '../../components/ExcerciseTypes/Circle_Write'

const json = {
	1: {
		unit: 'Unit 2',
		id: 'FP8-WB-demo-2023-U1-P15-E1',
		audio: '',
		video: '',
		recorder: true,
		exerciseKey: '/img/FriendsPlus/Page15/Key/E1answerKey.jpg',
		component: Circle_Write,
		titleQuestion: [
			{
				num: '1',
				title: `Choose the correct words to complete 
				the table.`,
				color: 'rgb(120,199,215)',
				star:1
			},
		],
		question: {
			Write: {
				inputStyle: {
					width: 120,
					textAlign: 'center',
				},
				answers: [``],
				initialValue: [],
			},
			Circle: {
				initialWordStyle: {
					padding: '-40px',
					// fontWeight: 600,
					color: '',
					// fontSize: 27,
					borderRadius: '50%',
					// marginInline: '-1px',
				},
				selectWordStyle: { border: '3px solid rgb(0, 173, 238)' ,padding:'5px'},
				limitSelect: 1,
				listWordsStyle: {},
				listWords: [
					'written / wrote',
					'has / have',
					'seen / saw',
					'hasn’t / haven’t',
					'ate / eaten',
					'hasn’t / haven’t',
					'come / came',
					'has / hasn’t',
					'have / haven’t'
				],
				answers: ['0-0', '1-0', '2-0', '3-4', '4-4', '5-0', '6-0', '7-0', '8-4'],
				initialValue: [],
			},
			Layout: `
			<div style='position: relative;'>
			<div style='display:flex'>
				<img src="/img/FriendsPlus/Page15/E1/1.jpg" style='height:26cm;'  >
			</div>
			<div>
			<div style=" position: absolute; top: 140px; left: 980px;display:flex;font-weight:bold;font-size:35px" ><input id="0" type="Circle"/></div>
			<div style=" position: absolute; top: 300px; left: 490px;display:flex;font-weight:bold;font-size:35px"><input id="1" type="Circle" /></div>
			<div style="position: absolute; top: 300px; left: 940px;display:flex;font-weight:bold;font-size:35px"><input id="2" type="Circle" /></div>
			<div style="position: absolute; top: 470px; left: 490px;display:flex;font-weight:bold;font-size:35px "><input id="3" type="Circle" /></div>
			<div style="position: absolute; top: 470px; left: 940px;display:flex;font-weight:bold;font-size:35px"><input id="4" type="Circle" /></div>
			<div style=" position: absolute; top: 620px; left: 490px;display:flex;font-weight:bold;font-size:35px "><input id="5" type="Circle" /></div>
			<div style=" position: absolute; top: 620px; left: 940px;display:flex;font-weight:bold;font-size:35px "><input id="6" type="Circle" /></div>
			<div style=" position: absolute; top: 800px; left: 220px;display:flex;font-weight:bold;font-size:35px "><input id="7" type="Circle" /></div>
			<div style=" position: absolute; top: 870px; left: 220px;display:flex;font-weight:bold;font-size:35px "><input id="8" type="Circle" /></div>
			</div>
					
        `,
		},
	},
	2: {
		unit: 'Unit 2',
		id: 'FP8-WB-demo-2023-U1-P15-E2',
		audio: '',
		video: '',
		// recorder: true,
		exerciseKey: '/img/FriendsPlus/Page15/Key/E2answerKey.jpg',
		isHiddenCheck:true,
		component: T6,
		inputSize: 190,
		titleQuestion: [
			{
				num: '2',
				title: ` Correct the words.`,
				color: 'rgb(120,199,215)',
				star:2,
			},
		],
		questionImage: [],
		stylesTextInput: {
			background: "transparent",
			border: "none",
			borderBottom: "1px solid gray",
			fontSize: "21px",
			textAlign: "center",
		  },
		questions: [
			{
				title: `
				<div style='position: relative;'>
				<div style='display:flex'>
					<img src="/img/FriendsPlus/Page15/E2/1.jpg" style='height:26cm;'  >
				</div>
				<div>
				<div style=" position: absolute; top: 77px; left:180px;display:flex;font-weight:bold;font-size:35px" ><input id="0" type="Circle"/></div>
				<div style=" position: absolute; top: 149px; left: 180px;display:flex;font-weight:bold;font-size:35px"><input id="1" type="Circle" /></div>
				<div style="position: absolute; top: 220px; left: 220px;display:flex;font-weight:bold;font-size:35px"><input id="2" type="Circle" /></div>
				<div style="position: absolute; top: 292px; left: 110px;display:flex;font-weight:bold;font-size:35px "><input id="3" type="Circle" /></div>
				<div style="position: absolute; top: 378px; left: 200px;display:flex;font-weight:bold;font-size:35px"><input id="4" type="Circle" /></div>
				<div style=" position: absolute; top: 450px; left: 110px;display:flex;font-weight:bold;font-size:35px "><input id="5" type="Circle" /></div>

				</div>
        `,
				answer: [
					"have learned", "has wanted", "has ever done", 
"has made", "has never cooked", "haven't tasted" 
				],
			},
		],
	},
	3: {
		unit: 'Unit 2',
		id: 'FP8-WB-demo-2023-U1-P15-E3',
		audio: '',
		video: '',
		// recorder: true,
		exerciseKey: '/img/FriendsPlus/Page15/Key/E3answerKey.jpg',
		component: T6,
		inputSize: 510,
		textAlign: 'left',
		titleQuestion: [
			{
				num: '3',
				title: `Write sentences using the present perfect.`,
				color: 'rgb(120,199,215)',
				star:2
			},
		],
		questionImage: [],
		questions: [
			{
				title: `
            <div>
				<div>she / not taste Indian food</div>
				<div><strong>She hasn’t tasted Indian food.</strong></div>
				<div><strong style="margin-right:15px">1</strong>Lucy / buy a new perfume</div>
				<div>#</div>
				<div><strong style="margin-right:15px">2</strong>we / not listen to rap music</div>
				<div>#</div>
				<div><strong style="margin-right:15px">3</strong>you / eat a lot of cake</div>
				<div>#</div>
				<div><strong style="margin-right:15px">4</strong>I / hear that joke befor</div>
				<div>#</div>
				<div><strong style="margin-right:15px">5</strong>Henry / not watch the film</div>
				<div>#</div>
				<div><strong style="margin-right:15px">6</strong>they / not see the painting</div>
				<div>#</div>
			</div>
        `,
				answer: [
					"Lucy has bought a new perfume.", 
"We haven't listened to rap music.",
"You've eaten a lot of cake.",
"I've heard that joke before.",
"Henry hasn't watched the film.", 
"They haven't seen the painting.",
				],
			},
		],
	},
	4: {
		unit: 'Unit 2',
		id: 'FP8-WB-demo-2023-U1-P15-E4',
		audio: '',
		video: '',
		// recorder: true,
		exerciseKey: '/img/FriendsPlus/Page15/Key/E4answerKey.jpg',
		component: Circle_Write,
		// inputSize: 110,
		textAlign: 'center',
		titleQuestion: [
			{
				num: '4',
				title: `Choose the correct answers.`,
				color: 'rgb(120,199,215)',
				star:2
			},
		],
		question: {
			Write: {
			  isHiddenCheck: true,
			  maxLength: 11,
			  inputStyle: { width: 100, fontSize: 19, textAlign: 'center' },
			  answers: [''],
			  initialValue: [],
			},
			Circle: {
			  initialWordStyle: {
				padding: 0,
				borderRadius: '50%',
				fontWeight: 'bold',
				borderColor: 'transparent',
			  },
			  selectWordStyle: {
				padding: 5,
				border: 'solid 2px',
				// borderColor: '#00aeef',
			  },
			  limitSelect: 1,
			  listWords: [
				`a <br> b <br> c`, //1
				`a <br> b <br> c`, //1
				`a <br> b <br> c`, //1
				`a <br> b <br> c`, //1
				`a <br> b <br> c`, //1
				
	  
	  
	  
			  ],
			  answers: ['0-0', '1-8', '2-8', '3-0', '4-0'],
			  initialValue: [],
			},
			Layout: `
			<div>That school has been there for........</div>
			<div style="font-size:20px"><strong style="border:3px solid black;border-radius:50%;padding:5px">a</strong> forty years &emsp;<b>b</b> 1975&emsp;<b>c</b> I was born</div>
			<div style='display:flex;font-size:20px'>
		<div style='flex: 1'>
		  <b>1</b>&ensp;I’ve loved pasta since I ........ a child.
		  <div style="display: flex;">
			<div style="display: flex; margin-left: 40px">
			  <div><input id='0' type='Circle'/></div>
			  <div style='margin-left:20px'>
				was <br> have been <br> am
			  </div>
			</div>
		  </div>
	  
		  <div style ='flex:1;'>
			<b>2</b>&ensp; We’ve been in this flat .......... six months.   <br>
			<div style="display: flex;margin-left:40px">
			  <div><input id='1' type='Circle'/></div>
			  <div style='margin-left:20px'>
			  since <br> from <br> for
			  </div>
			</div>
	  
			<b>3</b>&ensp;........a chef for five years.  <br>
			<div style="display: flex;margin-left:40px">
			  <div><input id='2' type='Circle'/></div>
			  <div style='margin-left:20px'>
			  He’s being <br> He's <br> He's been
			  </div>
			</div>
	  
			<b>4</b>&ensp; Kemal has had no sense of smell for........
		  <div style="display: flex;margin-left:40px">
			<div><input id='3' type='Circle'/></div>
			<div style='margin-left:20px'>
			ages <br> she was born <br> last year
	  
			</div>
		  </div>
			<b>5</b>&ensp; We haven’t visited our grandparents since........
		  <div style="display: flex;margin-left:40px">
			<div><input id='4' type='Circle'/></div>
			<div style='margin-left:20px'>
				   last year <br> six months <br> a long time
	  
			</div>
		  </div>
	  
		  </div>
		</div>
	  
	
	  </div>
	  
	   
	  
			  
			`,
		  },
	},
	5: {
		unit: 'Unit 2',
		id: 'FP8-WB-demo-2023-U1-P15-E5',
		audio: '',
		video: '',
		// recorder: true,
		exerciseKey: '',
		component: T6,
		inputSize: 610,
		textAlign: 'center',
		hideBtnFooter:true,
		titleQuestion: [
			{
				num: '5',
				title: `Write one or two sentences about these 
				things. Use for or since and the present perfect.`,
				color: 'rgb(120,199,215)',
				star:3
			},
		],
		questionImage: [],
		textareaStyle:{
			width:'800px'
		},
		questions: [
			{
				title: `
             <div>
				<div>where you live</div>
				<div><strong>I’ve lived in Istanbul since I was four.<br>
				We’ve lived in our new house for a year.</strong></div>
				<div><strong style="margin-right:15px">1</strong>hobbies your brother, sister or friend has</div>
				<textarea id="0" rows="2"></textarea>
				<div><strong style="margin-right:15px">2</strong>your parents’ jobs</div>
				<textarea id="1" rows="2"></textarea>
				<div><strong style="margin-right:15px">3</strong>things you and your friends haven’t done for a while</div>
				<textarea id="2" rows="2"></textarea>
				<div><strong style="margin-right:15px">4</strong>places you haven’t been to for a while</div>
				<textarea id="3" rows="2"></textarea>
			 </div>
        `,
				answer: [
					``,
				],
			},
		],
	},
	
}

export default json
